import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { buttonVariants } from '@ludus/ui'
import type { PipelineId } from '@ludus/core'
import { CenteredPanel } from '@/shared/feedback/CenteredPanel.tsx'

export function NoStages({ pipelineId }: { pipelineId: PipelineId }) {
  const { t } = useTranslation()
  return (
    <CenteredPanel
      title={t('pages.pipelines.noStages.title', { defaultValue: 'No stages yet' })}
      body={t('pages.pipelines.noStages.body', {
        defaultValue:
          'Stages are what the board is made of, and this pipeline has none yet — open its settings, or connect an external source to mirror the stages it already has.',
      })}
      muted
    >
      <Link
        to={`/pipelines/${pipelineId}/settings`}
        className={buttonVariants({ variant: 'primary', size: 'sm' })}
      >
        {t('pages.pipelines.noStages.configure', { defaultValue: 'Pipeline settings' })}
      </Link>
    </CenteredPanel>
  )
}
